// import * as options from 'vfm/options/basic'
// import {
//   usstates
// } from 'us-states/us-states'
// import email1 from 'vfm/email1.html'

export const meta = {
  form_name: 'Meal Plan Change Request',
  poc_name: 'Residence Life',
  poc_email: 'reslife@sdsmt.edu',
  //poc_email:  'Vickie.Bender@sdsmt.edu',
  poc_dept: 'Residence Life',
  root: 'dining',
  sub: 'meal-plan-change',
  closed: false
}

export const intro = {
  title: 'Meal Plan Change Request',
  subtitle: '',
  desc: '<p>Only one change allowed per semester. Changes for the Fall 2024 semester must be submitted prior to 4:00pm on September 3, 2024. Changes submitted for the Fall semester will automatically be applied to Spring.</p><p>NOTICES:<br />* First Year students must select one of these three plans. They are ineligible for all other plans.</p><p>** The Rocker Square Flex Plan is available only to residents in Rocker Square Apartments.</p><p>*** If you are switching from the Gold Rush, Hardrocker 160, Hardrocker 125 or Hardrocker 75 to either the Hardrocker Flex or Rocker Square Flex plans, any plan swipe usage will be charged out of your flex based on the meal period used.</p>'
};

const email1 = {
  from_name: meta.poc_dept,
  from: meta.poc_email,
  to: meta.poc_email,
  subject: meta.form_name + ' Submission ',
  body: 'body1'
};

const email2 = {
  from_name: meta.poc_dept,
  from: meta.poc_email,
  to: 'self',
  subject: meta.form_name + ' Submission ',
  body: 'body2'
};

const mealplans = [
        'Gold Rush*',
        'Hardrocker 160*',
        'Hardrocker 125*',
        'Hardrocker 75',
        'Hardrocker Flex',
        'Rocker Square Flex**'];

export const results = {
  miners: '',
  post: 'Y',
  enroll: '',
  stamp: '',
  confirm: 'https://interact.sdsmt.edu/' + meta.root + '/' + meta.sub + '-confirm.asp',
  emails: [email1,email2],
  action: '',
  csv_files: [{
    omit: [''],
    path: meta.root + '/',
    file: meta.sub + '.csv'
  }]
};

export const path_hash = '';

export const terms = {
     show: true,
     label: 'I agree to change my current meal plan and understand I agree to change my current meal plan and understand changes will be reflected on my account within one week when submitted prior to the start of the semester or within 3 business days when submitted on or after the first day of classes. I further understand that meal plans are priced for each semester. Meal Plan Meals are non-refundable and must be used within the semester of purchase. Meal Plan Flex transfers from fall to spring are forfeited if student does not purchase a plan or is not attending spring semester. Meal Plan Flex is not transferrable from spring to fall and is non-refundable. Residential students are required to purchase a meal plan. All plans include a bond and utility fee.',
     data: ''
};

export const items = {
    vfm_first_name: {
      section_header: '',
      name: 'FirstName',
      data: '',
      label: 'First Name',
      help: '',
      type: 'text',
      init: {
        placeholder: 'first name',
        options: ''
      },
      reqs: 'required',
      show: true
    },
    vfm_last_name: {
      name: 'LastName',
      data: '',
      label: 'Last Name',
      help: '',
      type: 'text',
      init: {
        placeholder: 'last name',
        options: ''
      },
      reqs: 'required',
      show: true
    },
  vfm_id: {
    name: 'IDNumber',
    data: '',
    label: 'ID Number',
    help: '',
    type: 'text',
    init: {
      placeholder: 'id',
      options: ''
    },
    reqs: 'required',
    show: true,
  },
  vfm_email: {
    name: 'Email',
    data: '',
    label: 'Mines Email Address',
    help: '',
    type: 'text',
    init: {
      placeholder: 'email@address.com',
      options: ''
    },
    reqs: 'required|email',
    show: true,
  },
  vfm_old_plan: {
    name: 'PrevPlan',
    data: '',
    label: 'Current Meal Plan',
    help: '',
    type: 'select',
    init: {
      placeholder: 'Select one...',
      options: mealplans
    },
    reqs: 'required',
    show: true,
  },
    vfm_new_plan: {
      name: 'NewPlan',
      data: '',
      label: 'New Plan Request',
      help: '',
      type: 'select',
      init: {
        placeholder: 'Select one...',
        options: mealplans
      },
      reqs: 'required',
      show: true,
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vfm/form-specs.js
// module id = phfT
// module chunks = 0